import Validator from 'validatorjs'
import {t, lang} from 'helpers/i18n'

// Load required languages (en loaded by default)
Validator.setMessages('es', require('validatorjs/src/lang/es'))

Validator.useLang(lang)
Validator.setAttributeFormatter(attribute => t(attribute.replace(/.+\./, '')))

export class Validation {
  private validator: Validator

  constructor(values: object, schema: object) {
    this.validator = new Validator(values, this.parseSchema(schema))
  }

  get valid() {
    return this.validator.passes()
  }

  get errors() {
    return this.validator.errors.all()
  }

  private parseSchema(schema: object) {
    return Object.keys(schema).reduce((newSchema, key) => {
      if (schema[key]) newSchema[key] = schema[key].result
      return newSchema
    }, {})
  }
}

export class Rules {
  private _rules: string[] = []

  get result() {
    return this._rules.join('|')
  }

  get isRequired() {
    return this._rules.indexOf('required') > -1
  }

  private set rules(value: string) {
    this._rules.push(value)
  }

  accepted() {
    this.rules = 'accepted'
    return this
  }

  after(date: string) {
    this.rules = `after:${date}`
    return this
  }

  afterOrEqual(date: string) {
    this.rules = `after_or_equal:date:${date}`
    return this
  }

  alpha() {
    this.rules = 'alpha'
    return this
  }

  alphaDash() {
    this.rules = 'alpha_dash'
    return this
  }

  array() {
    this.rules = 'array'
    return this
  }

  before(date: string) {
    this.rules = `before:${date}`
    return this
  }

  beforeOrEqual(date: string) {
    this.rules = `before_or_equal:date:${date}`
    return this
  }

  between(min: number, max: number) {
    this.rules = `between:${min},${max}`
    return this
  }

  boolean() {
    this.rules = 'boolean'
    return this
  }

  confirmed() {
    this.rules = 'confirmed'
    return this
  }

  date() {
    this.rules = 'date'
    return this
  }

  digits(value: number) {
    this.rules = `digits:${value}`
    return this
  }

  different(field: string) {
    this.rules = `different:${field}`
    return this
  }

  email() {
    this.rules = 'email'
    return this
  }

  in(array: string[] | number[]) {
    this.rules = `in:${array}`
    return this
  }

  integer() {
    this.rules = 'integer'
    return this
  }

  max(value: number) {
    this.rules = `max:${value}`
    return this
  }

  min(value: number) {
    this.rules = `min:${value}`
    return this
  }

  notIn(array: string[] | number[]) {
    this.rules = `not_in:${array}`
    return this
  }

  number() {
    this.rules = 'numeric'
    return this
  }

  object() {
    this.rules = 'object'
    return this
  }

  required() {
    this.rules = 'required'
    return this
  }

  requiredIf(anotherfield: string, value: string) {
    this.rules = `required_if:${anotherfield},${value}`
    return this
  }

  requiredUnless(anotherfield: string, value: string) {
    this.rules = `required_unless:${anotherfield},${value}`
    return this
  }

  requiredWith(anotherfields: string[] | number[]) {
    this.rules = `required_with:${anotherfields}`
    return this
  }

  requiredWithAll(anotherfields: string[] | number[]) {
    this.rules = `required_with_all:${anotherfields}`
    return this
  }

  requiredWithout(anotherfields: string[] | number[]) {
    this.rules = `required_without:${anotherfields}`
    return this
  }

  requiredWithoutAll(anotherfields: string[] | number[]) {
    this.rules = `required_without_all:${anotherfields}`
    return this
  }

  same(field: string) {
    this.rules = `same:${field}`
    return this
  }

  size(value: string) {
    this.rules = `size:${value}`
    return this
  }

  string() {
    this.rules = 'string'
    return this
  }

  url() {
    this.rules = 'url'
    return this
  }

  regex(pattern: RegExp) {
    this.rules = `regex:${pattern}`
    return this
  }
}

export const rules = () => new Rules()



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helpers/Validation.ts